// eslint-disable-next-line import/prefer-default-export
export enum DrawerType {
  COMPANY_ADD = 'COMPANY_ADD',
  COMPANY_ADD_FROM_CONTACT = 'COMPANY_ADD_FROM_CONTACT',
  CONTACT_ADD = 'CONTACT_ADD',
  INTERACTION_VIEW = 'INTERACTION_VIEW',
  INVITE_USERS = 'INVITE_USERS',
  FIELD_ADD = 'FIELD_ADD',
  FIELD_EDIT = 'FIELD_EDIT',
  REMINDER_ADD = 'REMINDER_ADD',
  REMINDER_VIEW = 'REMINDER_VIEW',
  FIELD_VIEW = 'FIELD_VIEW',
}
